import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { HomeWidgetsQuery } from './HomeWidgetsQuery.graphql';

export function preloadHomeWidgets({ isLicensed }: { isLicensed: boolean }) {
	if (!isLicensed) {
		return Promise.resolve();
	}

	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: HomeWidgetsQuery,
	});
}
